import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { Container, Typography, Box, Paper, Button } from "@mui/material";
import { investorApi } from "../../../api/api";
import { useNavigate } from "react-router-dom";

const WalletBalance = () => {
  const userId = useSelector((state) => state.user.userId);
  const [walletBalance, setWalletBalance] = useState(0);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
const theme=useSelector((data)=>data.themeValue.colors)
const themeMode=useSelector((data)=>data.themeValue.theme)
  useEffect(() => {
     window.scrollTo({ top: 0, behavior: "smooth" });
    const fetchWalletBalance = async () => {
      try {
        if (!userId) {
          setLoading(false);
          return;
        }
        const response = await investorApi.getWalletBalance(userId);
        if (Array.isArray(response.data) && response.data.length > 0) {
          setWalletBalance(response.data[0].Balance);
        } else {
          setWalletBalance(0);
        }
      } catch (error) {
        console.error("Error fetching wallet balance:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchWalletBalance();
  }, [userId]);

  return (
    <Container
      maxWidth={false}
      disableGutters
      sx={{
        mt: { xs: 4, sm: 6, md: 8 },
        px: 0
      }}
    >
      <Paper
        elevation={5}
        sx={{
          width: "100%",
          borderRadius: 0,
          background: theme.background,
          boxShadow: "0 8px 30px rgba(0,0,0,0.08)",
        }}
      >
        <Box
          sx={{
            background:themeMode==="light"? "#e3f2fd":"#a4a4a6",
            p: { xs: 2, sm: 3 },  
            borderRadius: 3,
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "space-between",
            alignItems: { xs: "flex-start", sm: "center" },
            gap: 2,
            mb: 2,
            
          }}
        >
          <Box>
            <Typography
              variant="subtitle2"
              color="text.secondary"
              sx={{ fontSize: 14 ,color:theme.text}}
            >
              Total Balance
            </Typography>
            <Typography
              variant="h5"
              fontWeight="bold"
              sx={{ color: "#1976d2" }}
            >
              {loading ? "Loading..." : `₹ ${walletBalance}`}
            </Typography>
          </Box>
          {/* <Button
            fullWidth
            variant="contained"
            sx={{
              textTransform: "none",
              fontWeight: "bold",
              px: { xs: 2, sm: 3 },
              py: 1,
              borderRadius: 3,
              backgroundColor: "#1976d2",
              "&:hover": { backgroundColor: "#115293" },
              width: { xs: "100%", sm: "auto" },
            }}
            onClick={() => navigate("/AddWallet")}
          >
            + Add Balance
          </Button> */}
        </Box>
      </Paper>
    </Container>
  );
};

export default WalletBalance;
